var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPlayTillHere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2V4.75C15.188 4.75 17.2865 5.61919 18.8336 7.16637C20.3808 8.71354 21.25 10.812 21.25 13H24C24 10.0826 22.8411 7.28473 20.7782 5.22183C18.7153 3.15893 15.9174 2 13 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 14.375C4.13439 14.375 4.75 13.7594 4.75 13C4.75 12.2406 4.13439 11.625 3.375 11.625C2.61561 11.625 2 12.2406 2 13C2 13.7594 2.61561 14.375 3.375 14.375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93974 8.87635C6.31943 8.2187 6.0941 7.37776 5.43645 6.99807C4.7788 6.61837 3.93786 6.8437 3.55817 7.50135C3.17847 8.15901 3.4038 8.99994 4.06145 9.37964C4.7191 9.75933 5.56004 9.53401 5.93974 8.87635Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92312 5.98405C9.58379 5.60436 9.81156 4.76097 9.43187 4.1003C9.05217 3.43963 8.20879 3.21186 7.54812 3.59155C6.88745 3.97125 6.65967 4.81463 7.03937 5.4753C7.41906 6.13597 8.26245 6.36375 8.92312 5.98405Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4392 18.4982C22.8189 17.8405 22.5936 16.9996 21.936 16.6199C21.2783 16.2402 20.4374 16.4655 20.0577 17.1232C19.678 17.7808 19.9033 18.6218 20.561 19.0015C21.2186 19.3812 22.0596 19.1558 22.4392 18.4982Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5019 22.4394C19.1596 22.0597 19.3849 21.2188 19.0052 20.5611C18.6255 19.9035 17.7846 19.6782 17.1269 20.0579C16.4693 20.4376 16.244 21.2785 16.6237 21.9361C17.0034 22.5938 17.8443 22.8191 18.5019 22.4394Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13 24C13.7594 24 14.375 23.3844 14.375 22.625C14.375 21.8656 13.7594 21.25 13 21.25C12.2406 21.25 11.625 21.8656 11.625 22.625C11.625 23.3844 12.2406 24 13 24Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37681 21.9354C9.7565 21.2778 9.53118 20.4368 8.87352 20.0572C8.21587 19.6775 7.37494 19.9028 6.99524 20.5604C6.61554 21.2181 6.84087 22.059 7.49852 22.4387C8.15618 22.8184 8.99711 22.5931 9.37681 21.9354Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.43981 19.0017C6.09746 18.622 6.32279 17.7811 5.94309 17.1234C5.5634 16.4657 4.72246 16.2404 4.06481 16.6201C3.40716 16.9998 3.18183 17.8407 3.56152 18.4984C3.94122 19.1561 4.78216 19.3814 5.43981 19.0017Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.188 17.0179C10.9814 17.153 10.7734 17.1603 10.5641 17.0397C10.3547 16.919 10.25 16.7346 10.25 16.4862V9.17007C10.25 8.9217 10.3547 8.7372 10.5641 8.61658C10.7734 8.49597 10.9814 8.50322 11.188 8.63834L16.8405 12.3073C17.0302 12.4315 17.125 12.6058 17.125 12.8301C17.125 13.0544 17.0302 13.2273 16.8405 13.3489L11.188 17.0179Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlayTillHere);
export default __webpack_public_path__ + "static/media/iconPlayTillHere.df2634f9.svg";
export { ForwardRef as ReactComponent };